<cache-date></cache-date>

<period></period>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br />

<ngb-accordion #acc="ngbAccordion">
	<ngb-panel title="{{ 'adminstat.common.All count' | translate }}">
		<ng-template ngbPanelContent>
			<div class="row">
				<div class="col-md-12">
					<div class="table-responsive">
						<table class="table js-ul-total-billing-table">
							<thead>
							<tr>
								<th></th>
								<th>{{ 'adminstat.common.paidCount' | translate }}</th>
								<th>{{ 'adminstat.common.Money' | translate }}</th>
							</tr>
							</thead>

							<tbody>
							<tr *ngFor="let currency of currencyList; let i = index">
								<td>{{ i == 0 ? ('adminstat.common.All count' | translate)  : '' }}</td>
								<td>{{info.total[currency] ? info.total[currency].paidCount : 0}}</td>
								<td>{{info.total[currency] ? helper.convertAmountToDollar(info.total[currency].moneyCount, currency) : 0}}</td>
							</tr>
							<tr *ngFor="let currency of currencyList; let i = index">
								<td>{{ i == 0 ? ('adminstat.common.In query count' | translate)  : '' }}</td>
								<td>{{info.query[currency] ? info.query[currency].paidCount : 0}}</td>
								<td>{{info.query[currency] ? helper.convertAmountToDollar(info.query[currency].moneyCount, currency) : 0}}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</ng-template>
	</ngb-panel>
</ngb-accordion>

<br />

<chart [data]="chart.data" [options]="chart.options" (onFilterChange)="updateData($event, 'chart')" [sextant]="'chart'" [url]="filter.currentUrl"></chart>

<hr />

<br />

<ngb-pagination
	[extlinks]="links"
	[collectionSize]="pagination.pageCount"
	[maxSize]="10"
	[pageSize]="1" [(page)]="pagination.page"
	[boundaryLinks]="true"
	(pageChange)="onPageChange()"
	*ngIf="!paginationLoader && pagination.pageCount > 1"
></ngb-pagination>

<table class="table table-bordered table-nonfluid">
	<thead>
	<tr>
		<th>{{ 'adminstat.common.Date' | translate }}</th>
		<th>{{ 'adminstat.common.Total info' | translate }}</th>
		<th>{{ 'adminstat.common.Templates' | translate }}</th>
	</tr>
	</thead>
	<tbody>
		<tr *ngFor="let row of stats">
			<td [class]="[0, 6].includes(row.day) ? 'table-info' : 'fake'">{{row.currentPeriod}}</td>
			<td>
				<table class="table table-sm">
					<thead>
					<tr>
						<th></th>
						<th>All</th>
						<th *ngFor="let currency of currencyList">{{helper.currencyLabels[currency]}}</th>
					</tr>
					</thead>

					<tbody>
					<tr>
						<td>{{ 'adminstat.common.Money' | translate }}</td>
						<td>
							<button-anhor (click)="showDetails(row.timestamp, row.currentPeriod)">{{helper.convertAmountToDollar(row.totals.money['all'], 'usd')}}</button-anhor>
						</td>
						<td *ngFor="let currency of currencyList">{{row.totals.money[currency] ? helper.convertAmountToDollar(row.totals.money[currency]) : 0}}</td>
					</tr>

					<tr>
						<td>{{ 'adminstat.common.paidCount' | translate }}</td>
						<td>{{row.totals.paidCount['all']}}</td>
						<td *ngFor="let currency of currencyList">{{row.totals.paidCount[currency] ? row.totals.paidCount[currency] : 0}}</td>
					</tr>

					<tr>
						<td>{{ 'adminstat.common.userCount' | translate }}</td>
						<td>{{row.totals.userCount['all']}}</td>
						<td *ngFor="let currency of currencyList">{{row.totals.userCount[currency] ? row.totals.userCount[currency] : 0}}</td>
					</tr>
					</tbody>
				</table>
			</td>
			<td>
				<table class="table table-sm table-light">
					<thead>
					<tr>
						<th>{{ 'adminstat.template.template' | translate }}</th>
						<th>{{ 'adminstat.common.userCount' | translate }}</th>
						<th>{{ 'adminstat.common.Money' | translate }}</th>
						<th>{{ 'adminstat.common.paidCount' | translate }}</th>
					</tr>
					</thead>

					<tbody>
					<tr *ngFor="let template of row.templates | keys">
						<td>{{row.templates[template].templateId}}</td>
						<td>{{row.templates[template].userCount}}</td>
						<td>{{helper.convertAmountToDollar(row.templates[template].moneyCount, 'usd')}}</td>
						<td>{{row.templates[template].paidCount}}</td>
					</tr>
					</tbody>
				</table>
			</td>
		</tr>
	</tbody>
</table>


